/* eslint-disable @typescript-eslint/no-empty-function, @typescript-eslint/no-unused-vars */
/**
 * Base class for all Large containers which we can show.
 */
export default class LargeContainer {
    /* eslint-disable no-unused-vars, no-empty-function */
    /**
     * Show this container.
     * @returns Promise
     */
    show() {
    }
    /**
     * Hide this container.
     * @returns Promise
     */
    hide() {
    }
    /**
     * Resize this container.
     * @param {number} containerWidth available width
     * @param {number} containerHeight available height
     * @param {boolean} animate if container should animate it's resize process
     */
    // @ts-ignore
    resize(containerWidth, containerHeight, animate) {
    }
    /**
     * Handler for "hover in" events.
     */
    // @ts-ignore
    onHoverIn(e) {
    }
    /**
     * Handler for "hover out" events.
     */
    // @ts-ignore
    onHoverOut(e) {
    }
    /**
     * Update video stream.
     * @param {string} userID
     * @param {VietMeetTrack?} stream new stream
     * @param {string} videoType video type
     */
    // @ts-ignore
    setStream(userID, stream, videoType) {
    }
    /**
     * Show or hide user avatar.
     * @param {boolean} show
     */
    // @ts-ignore
    showAvatar(show) {
    }
    /**
     * Whether current container needs to be switched on dominant speaker event
     * when the container is on stage.
     * @return {boolean}
     */
    stayOnStage() {
    }
}
